// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Dashboard',
  subtitle: 'Overview and statistics',
  overview: 'Domain management and payment tracking overview',
  lastUpdate: 'Last Update',
  totalCustomers: 'Total Customers',
  activeCustomers: 'Active Customers',
  registeredCustomers: 'Registered customer count',
  totalDomains: 'Total Domains',
  activeDomains: 'Active Domains',
  totalServers: 'Total Servers',
  activeServers: 'Active server count',
  totalCompanies: 'Total Companies',
  totalPayments: 'Total Payments',
  pendingPayments: 'Pending Payments',
  pendingTransactions: 'Pending payment transactions',
  overduePayments: 'Overdue Payments',
  expiredPayments: 'Expired payments',
  totalRevenue: 'Total Revenue',
  totalCollection: 'Total collection',
  monthlyRevenue: 'This Month Revenue',
  yearlyRevenue: 'Yearly Revenue',
  recentPayments: 'Recent Payments',
  upcomingPayments: 'Upcoming Payments',
  expiringDomains: 'Expiring Domains',
  noData: 'No data available',
  fetchError: 'Dashboard data could not be retrieved',
  noPendingPayments: 'No pending payments for this month',
  noOverduePayments: 'No overdue payments',
  noRevenueThisMonth: 'No revenue for this month',
  daysOverdue: 'days overdue',
  monthly: 'Monthly',
  yearly: 'Yearly',
  oneTime: 'One Time'
};
